export const dummyData = $axios => ({
  create: (params = {}) => $axios.$post('/dummy_data', params),
  get: () => $axios.$get('/dummy_data'),
});
